import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "flow flow--7" }

import { ref, onBeforeUnmount } from 'vue';
import { SearchData } from '@/types';
import Pagenavigator from '../molecules/Pagenavigator.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    items: null,
    pageSize: null,
    hasNextPage: { type: Boolean }
  },
  emits: ["update:page"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:page', newPage: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  items: SearchData[];
  pageSize: number;
  hasNextPage: boolean;
}

const currentPage = ref(1);





emit('update:page', currentPage.value);

const nextPage = () => {
  if (props.hasNextPage) {
    currentPage.value += 1;
    emit('update:page', currentPage.value);
  }
};

const prevPage = () => {
  if (currentPage.value > 1) {
    currentPage.value -= 1;
    emit('update:page', currentPage.value);
  }
};

onBeforeUnmount(() => emit('update:page', 0));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(Pagenavigator, {
      "current-page": currentPage.value,
      "has-next-page": __props.hasNextPage,
      onNextPage: _cache[0] || (_cache[0] = ($event: any) => (nextPage())),
      onPrevPage: _cache[1] || (_cache[1] = ($event: any) => (prevPage()))
    }, null, 8, ["current-page", "has-next-page"]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items.slice(__props.pageSize * (currentPage.value - 1), __props.pageSize * currentPage.value), (item) => {
      return _renderSlot(_ctx.$slots, "default", {
        key: item.articleId,
        item: item
      })
    }), 128)),
    _createVNode(Pagenavigator, {
      "current-page": currentPage.value,
      "has-next-page": __props.hasNextPage,
      onNextPage: _cache[2] || (_cache[2] = ($event: any) => (nextPage())),
      onPrevPage: _cache[3] || (_cache[3] = ($event: any) => (prevPage()))
    }, null, 8, ["current-page", "has-next-page"])
  ]))
}
}

})